<template>
    <label class="block relative" :class="{ 'max-w-4xl': !fullWidth }">
        <div class="flex justify-between">
            <span class="text-gray-700 dark:text-gray-200">{{ label }}</span>
            <span v-if="maxlength" class="text-gray-500 dark:text-gray-300">{{charInserted}} out of {{maxlength}}</span>
        </div>
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span class="text-gray-500 dark:text-gray-300 sm:text-sm">
                <slot name="prepend"></slot>
            </span>
        </div>
        <input
            :class="[
                $slots.prepend ? 'pl-6' : null,
                error ? 'border-red-600 dark:border-red-300' : 'border-gray-300 dark:border-gray-500'
            ]"
            class="block w-full rounded-md bg-white dark:bg-gray-700 text-black dark:text-white focus:border-blue-300 dark:focus:border-blue-500 focus:ring focus:ring-blue-200 dark:focus:ring-blue-400 focus:ring-opacity-50 mt-1 disabled:opacity-50"
            :name="name"
            :type="type || 'text'"
            :step="step"
            :maxlength="maxlength"
            :max="max"
            :min="min"
            @input="(e) => $emit('input', e.target.value)"
            @change="(e) => $emit('change', e.target.value)"
            @blur="(e) => $emit('blur')"
            @focus="(e) => { $emit('focus', e); if (selectOnFocus) { e.target.select(); } }"
            :value="value"
            :disabled="disabled"
            :data-lpignore="lpignore"
            :placeholder="placeholder"
            ref="inputText"
            :keyup="countdown"
        />
        <slot></slot>
        <error class="mt-1" :error="error" />
    </label>
</template>

<script>
export default {
    name: "InputText",
    props: {
        name: String,
        label: String,
        value: [String, Number],
        type: String,
        selectOnFocus: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        lpignore: {
            type: Boolean,
            required: false,
            default: false,
        },
        step: {
            type: Number,
            required: false,
        },
        maxlength: {
            type: Number,
            required: false,
        },
        max: {
            type: Number,
            required: false,
        },
        min: {
            type: Number,
            required: false,
        },
        error: {
            type: String,
            required: false,
        },
        before: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        fullWidth: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            charInserted: 0
        };
    },
    computed: {
        countdown () {
            this.charInserted = this.value ? this.value.length : 0;
        },
    },
};
</script>
